import { useState } from "react";
import { DateTimeInternalFormat } from "../../api/datetimeUtil";
import { utc } from "../timezone";
import { ProgramExecution } from "./types";
import { useSmartList } from "../../hooks/useSmartList";
import { useThrottledCapture } from "../primitives";

interface ExecutionsLogFilter {
  before?: string;
  after?: string;
}

const getDefaultFilter = (): ExecutionsLogFilter => ({
    after: utc.toServer(new Date()).add({ days: -1 }).format(DateTimeInternalFormat),
})

export const useRobudExecutions = (apiPath: string, defaultFilter?: ExecutionsLogFilter) => {
    const [filter, setFilter] = useState<Partial<ExecutionsLogFilter>>(defaultFilter || getDefaultFilter());
    const appliedFilter = useThrottledCapture(filter, 500);

    const data = useSmartList<ProgramExecution>(`${apiPath}/execution`, {
      extraParams: appliedFilter,
      noView: true,
      noCount: true,
      schema: {},
      newRecordDefault: {},
    });

    return {
        ...data,
        filter,
        updateFilter: (c: Partial<ExecutionsLogFilter>) => setFilter(f => ({ ...f, ...c })),
        resetFilter: () => setFilter(defaultFilter || getDefaultFilter()),
        requestLoad: () => {},
    }
}
